module.exports = __webpack_public_path__ + "static/media/React95Video-Numbers.76ac7878.eot";